import {Component,ElementRef,EventEmitter,OnInit,Output, ViewChild,} from '@angular/core';
import { AlertboxComponent } from '../alertbox/alertbox.component';
import { FormBuilder,FormControl,FormGroup,Validators,} from '@angular/forms';
import { UmsService } from '../ums.service';
import { ModalpopService } from '../modalpop.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { DatePipe } from '@angular/common';
import { MatDialogRef, MatDialog } from '@angular/material/dialog';
import {HttpClient, HttpErrorResponse} from '@angular/common/http';
import { Observable, Subscriber } from 'rxjs';
import { PdfviewerComponent } from '../pdfviewer/pdfviewer.component';
import * as html2pdf from 'html2pdf.js';
import { Location } from '@angular/common';
@Component({
  selector: 'app-download-details',
  templateUrl: './download-details.component.html',
  styleUrls: ['./download-details.component.scss'],
})
export class DownloadDetailsComponent implements OnInit {
  @ViewChild('contentToConvert') contentToConvert!: ElementRef;
  @Output() next = new EventEmitter<void>();
  @Output() prev = new EventEmitter<void>();
  dialogRef: MatDialogRef<any>;
  disabled = false;
  FormRequired = '*';
  session = sessionStorage.getItem('session');
  DownloadDetails: any;
  isreadonly = false;
  years: number[] = this.generateYears(1970, new Date().getFullYear());
  fileName: string;
  qualList: any;
  isDivShow: boolean;
  APIService: string;
  resultNotDec = false;
  showtxt = false;
  notOpen = false;
  AdmClosed = false;
  InstId: any;
  Subs = false;
  OptSub = false;
  noCheckboxSelected = false;
  SubjectName: any[] = [];
  AllSub: any[] = [];
  Sub: any[] = [];
  optData: any;
  optDataForGroup: any;
  checkedValues: any;
  code: any;
  msg: any;
  SubjectData = [];
  parsedData: any;
  FromDate: Date;
  ToDate: Date;

  errormessage: string;
  uploadDoc: any;
  filePre: any;
  imgFile: any;
  ducumentList: any;
  errMsg: any;
  addmissionData: any;
  inputTimeout: any;
  StuSrNum;
  StuDocName;
  StuRmk;
  userImage: any;
  signatureImage: any;
  userSign: string;
  proId: any;
  InsNm: any;
  HideAbcId =false;
  HideAddhar =false;
  ShowAadharNo=false;
  constructor(
    private fb: FormBuilder, private location: Location,
    public umsService: UmsService,
    private modalPopupService: ModalpopService,
    private spinner: NgxSpinnerService,
    public datepipe: DatePipe,
    public dialog: MatDialog
  ) {}
  @ViewChild('fileUploader') fileUploader: ElementRef;
  personalDetailsForm: FormGroup;
  contactDetailsForm: FormGroup;
  contactDetailsFormArray;
  submitButton = true;
  updateButton = false;
  minDate: Date;
  currentdate: any;
  FirstName: string;
  MiddleName: string;
  LastName: string;
  Number: number;
  Email: string;
  personalDetailsFormArray;
  selectedIndex: number = 0;
  studentId = sessionStorage.getItem('StudentRGID');
  reservationsDetailsFormArray;
  reservationsDetailsForm: FormGroup;
  disableMinority = true;
  valueForMakeReq: any;
  valueForMakeReq1: any;
  StudentPersonalId = sessionStorage.getItem('StudentPersonalId');
  enable = false;
  qualificationDetailsForm: FormGroup;
  nextButton = false;
  deleteButton = false;
  delReadOnly = false;
  resetButton = false;
  qualificationDetailsFormArray;
  additionalDetailsForm: FormGroup;
  additionalDetailsFormArray;
  admissionDetailsForm: FormGroup;
  BranchId = 0;
  admissionDetailsFormArray;
  selectedValues: any[] = [];
  newSelectedValues = [];
  Subjects: any[] = [];
  GroupData: any[] = [];
  selectedCheckboxes: any = [];
  selectedOptions: any = [];
  validationErrors: { [key: string]: string } = {};
  MinMax = false;
  sessionList: any[];
  SessionFilterList: any[];
  documentDetailsForm: FormGroup;
  CoId;
  CgId;
  photoSignDetailsForm: FormGroup;
  ngOnInit(): void {
    this.Subs = false;
    this.OptSub = false;
    this.noCheckboxSelected = false;
    this.MinMax = false;
    this.notOpen = false;
    this.AdmClosed = false;
    this.validationErrors = {};
    this.StudentPersonalId = sessionStorage.getItem('StudentPersonalId');
    this.session = sessionStorage.getItem('session');
    this.submitButton = true;
    this.updateButton = false;
    this.disabled = false;
    this.BranchId = 0;
    let a = sessionStorage.getItem('userId');
    this.disabled = false;
    this.currentdate = new Date();
    this.minDate = new Date(1900, 0, 1);
    this.submitButton = true;
    this.updateButton = false;
    this.getUserData(sessionStorage.getItem('StudentRGID'));
    this.personalDetailsForm = this.fb.group({
      StuRgNo: new FormControl(this.studentId),
      StuId: new FormControl(''),
    });
    this.contactDetailsForm = this.fb.group({
      StuId: new FormControl(this.StudentPersonalId),
      StuAddrId: new FormControl(),
    });

    this.reservationsDetailsForm = this.fb.group({
      StuId: new FormControl(this.StudentPersonalId),
      StuResId: new FormControl(''),
    });
    this.qualificationDetailsForm = this.fb.group({
      StuId: new FormControl(this.StudentPersonalId),
      StuQualId: new FormControl(),
    });
    this.additionalDetailsForm = this.fb.group({
      StuId: new FormControl(this.StudentPersonalId),
      StuExtraId: new FormControl(),
    });
    this.admissionDetailsForm = this.fb.group({
      StuId: new FormControl(this.StudentPersonalId),
      SubChecked: new FormControl(''),
    });
    this.photoSignDetailsForm = this.fb.group({
      StuId: new FormControl(this.StudentPersonalId),
      StuRgNo: new FormControl(this.studentId),
      StuPhoto: new FormControl('', Validators.required),
      StuSignature: new FormControl('', Validators.required),
    });
    this.documentDetailsForm = this.fb.group({
      "StuRemarkConfirm": new FormControl(''),
      "StuRemarkCheck": new FormControl('', Validators.required),
      arrData: this.fb.array([]),
    });
    this.prepop_fetchPersonalDetails();
    this.getScretData();
  }

  getUserData(id) {
    this.spinner.show()
    this.FirstName = '';
    this.MiddleName = '';
    this.LastName = '';
    this.Number = 0;
    this.Email = '';
    this.umsService.getUserData(id).subscribe((res) => {
      if(res.status){
        this.spinner.hide()
      this.FirstName = res.data[0][0]['StuFirstName'];
      this.MiddleName = res.data[0][0]['StuMidName'];
      this.LastName = res.data[0][0]['StuLastName'];
      this.Number = parseInt(res.data[0][0]['StuMobNumber']);
      this.Email = res.data[0][0]['StuEmailId'];
      }
      else{
        this.spinner.hide();
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
    });
  }

  generateYears(startYear: number, endYear: number): number[] {
    const years = [];
    for (let year = startYear; year <= endYear; year++) {
      years.push(year);
    }
    return years;
  }

  onYearSelect(event: any) {
    const selectedYear = event.value;
  }

  prepop_fetchPersonalDetails() {
    this.spinner.show()
    let payload = {};
    payload['StuRgNo'] = this.studentId;
    this.umsService.fetchPersonalDetails(payload).subscribe((res) => {
      if (res.status) {
        this.spinner.hide();
        if (res.data.length > 0) {
          sessionStorage.setItem('StudentPersonalId', res.data[0].StuId);
          this.submitButton = false;
          this.updateButton = true;
          this.spinner.hide();
          res.data[0].StuBirthDate = this.formatDate(res.data[0].StuBirthDate);
          this.prepop_fetchPersonalDetails_Form(res);
        }
      }
      else{
        this.spinner.hide();
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
    });
  }

  formatDate(dateString: string): string {
    const [year, month, day] = dateString.split('-');
    return `${day}/${month}/${year}`;
  }

  prepop_fetchPersonalDetails_Form(e) {
    this.spinner.show()
    let payload = {};
    payload['FormPage'] = 'PersonalDetails';
    this.personalDetailsForm.controls['StuId'].setValue(e.data[0]['StuId']);
    this.umsService.getStdSetting(payload).subscribe(async (ress) => {
      this.spinner.hide()
      ress.data.forEach((element) => {
        if (element.FormVisible) {
          if (
            element.FormControlName == 'EmailID' &&
            element.FormRequired == true
          ) {
            this.personalDetailsForm.addControl(
              element.FormControlName,
              new FormControl(e.data[0][element.FormControlName], [
                Validators.required,
                Validators.email,
                Validators.pattern(
                  '(?![0-9]+@)[A-Za-z0-9._%-]+@[A-Za-z0-9._%-]+\\.[a-z]{2,3}'
                ),
              ])
            );
          } else if (
            element.FormControlName == 'EmailID' &&
            element.FormRequired == false
          ) {
            this.personalDetailsForm.addControl(
              element.FormControlName,
              new FormControl(e.data[0][element.FormControlName], [
                Validators.email,
                Validators.pattern(
                  '(?![0-9]+@)[A-Za-z0-9._%-]+@[A-Za-z0-9._%-]+\\.[a-z]{2,3}'
                ),
              ])
            );
          }
          if (element.FormRequired) {
            if (element.FormPattern == '') {
              this.personalDetailsForm.addControl(
                element.FormControlName,
                new FormControl(
                  e.data[0][element.FormControlName],
                  Validators.required
                )
              );
            } else {
              this.personalDetailsForm.addControl(
                element.FormControlName,
                new FormControl(e.data[0][element.FormControlName], [
                  Validators.required,
                  Validators.pattern(element.FormPattern),
                ])
              );
            }
          } else {
            if (element.FormPattern == '') {
              this.personalDetailsForm.addControl(
                element.FormControlName,
                new FormControl(e.data[0][element.FormControlName])
              );
            } else {
              this.personalDetailsForm.addControl(
                element.FormControlName,
                new FormControl(e.data[0][element.FormControlName], [
                  Validators.pattern(element.FormPattern),
                ])
              );
            }
          }
        } else {
          this.personalDetailsForm.addControl(
            element.FormControlName,
            new FormControl(e.data[0][element.FormControlName])
          );
        }
      });
      this.submitButton = false;
      this.updateButton = true;
      this.mapdataaa(ress.data);
      await this.prepop_fetchContactDetails();
      await this.prepopulationPhoto();
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
    });
  }

  prepop_fetchContactDetails() {
    this.spinner.show()
    let payload = {};
    payload['StuId'] = this.StudentPersonalId;
    this.umsService.fetchContactDetails(payload).subscribe((res) => {
      if (res.status) {
        this.spinner.hide()
        if (res.data.length > 0) {
          this.umsService.disable2 = false;
          if (res.data[0].StuSameAddr == 1) {
            this.isreadonly = true;
          } else {
            this.isreadonly = false;
          }
          sessionStorage.setItem('StudentPersonalId', res.data[0].StuId);
          this.updateButton = true;
          this.submitButton = false;
          this.prepop_fetchContactDetails_Form(res);
        }
      }
      else{
        this.spinner.hide()
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
    });
  }

  prepop_fetchContactDetails_Form(e) {
    let payload = {};
    payload['FormPage'] = 'ContactDetails';
    this.contactDetailsForm.controls['StuAddrId'].setValue(
      e.data[0]['StuAddrId']
    );
    this.umsService.getStdSetting(payload).subscribe(async (ress) => {
      ress.data.forEach((element) => {
        if (element.FormVisible) {
          if (
            element.FormControlName == 'StuEmailId' &&
            element.FormRequired == true
          ) {
            this.contactDetailsForm.addControl(
              element.FormControlName,
              new FormControl(e.data[0][element.FormControlName], [
                Validators.required,
                Validators.email,
                Validators.pattern(
                  '(?![0-9]+@)[A-Za-z0-9._%-]+@[A-Za-z0-9._%-]+\\.[a-z]{2,3}'
                ),
              ])
            );
          } else if (
            element.FormControlName == 'StuEmailId' &&
            element.FormRequired == false
          ) {
            this.contactDetailsForm.addControl(
              element.FormControlName,
              new FormControl(e.data[0][element.FormControlName], [
                Validators.email,
                Validators.pattern(
                  '(?![0-9]+@)[A-Za-z0-9._%-]+@[A-Za-z0-9._%-]+\\.[a-z]{2,3}'
                ),
              ])
            );
          }
          if (element.FormRequired) {
            if (element.FormPattern == '') {
              this.contactDetailsForm.addControl(
                element.FormControlName,
                new FormControl(
                  e.data[0][element.FormControlName],
                  Validators.required
                )
              );
            } else {
              this.contactDetailsForm.addControl(
                element.FormControlName,
                new FormControl(e.data[0][element.FormControlName], [
                  Validators.required,
                  Validators.pattern(element.FormPattern),
                ])
              );
            }
          } else {
            if (element.FormPattern == '') {
              this.contactDetailsForm.addControl(
                element.FormControlName,
                new FormControl(e.data[0][element.FormControlName])
              );
            } else {
              this.contactDetailsForm.addControl(
                element.FormControlName,
                new FormControl(e.data[0][element.FormControlName], [
                  Validators.pattern(element.FormPattern),
                ])
              );
            }
          }
        } else {
          this.contactDetailsForm.addControl(
            element.FormControlName,
            new FormControl(e.data[0][element.FormControlName])
          );
        }
      });
      this.contactDetailsFormArray = ress.data.reduce(function (r, a) {
        r[a.FormControlName] = r[a.FormControlName] || [];
        r[a.FormControlName].push(a);
        return r;
      }, Object.create(null));
      await this.prepop_fetchReservationDetails();
    });
  }
  mapdataaa(e) {
    this.personalDetailsFormArray = e.reduce(function (r, a) {
      r[a.FormControlName] = r[a.FormControlName] || [];
      r[a.FormControlName].push(a);
      return r;
    }, Object.create(null));
  }
  ageCalculate() {
    if (
      this.personalDetailsForm.controls['StuBirthDate'].value <= this.minDate ||
      this.personalDetailsForm.controls['StuBirthDate'].value >=
        this.currentdate
    ) {
      this.personalDetailsForm.controls['StuAge'].setValue('');
      // this.personalDetailsForm.get('StuBirthDate').setErrors({
      //   'minIsGreaterThanMax': true
      // })
    } else {
      let payload = this.personalDetailsForm.value;
      if (payload.StuBirthDate) {
        var timeDiff = Math.abs(
          Date.now() - new Date(payload.StuBirthDate).getTime()
        );
        let age = Math.floor(timeDiff / (1000 * 3600 * 24) / 365.25);
        this.personalDetailsForm.controls['StuAge'].setValue(age);
      }
    }
  }

  back() {
    this.prev.emit();
  }

  fetchDownloadDetails() {
    this.spinner.show();
    const payload = {};
    payload['StuId'] = parseInt(sessionStorage.getItem('StudentPersonalId'));
    this.umsService.getDownloadDetails(payload).subscribe(async (res) => {
      if (res.status) {
        this.spinner.hide();
        this.DownloadDetails = res.data[0];
        if (this.DownloadDetails['StuGender']) {
          this.personalDetailsForm.controls['StuGender'].patchValue(
            this.DownloadDetails['StuGender']
          );
        }
        if (this.DownloadDetails['StuMotherTongue']) {
          this.personalDetailsForm.controls['StuMotherTongue'].patchValue(
            this.DownloadDetails['StuMotherTongue']
          );
        }
        if (this.DownloadDetails['EmailBelongsTo']) {
          this.personalDetailsForm.controls['EmailBelongsTo'].patchValue(
            this.DownloadDetails['EmailBelongsTo']
          );
        }
        if (this.DownloadDetails['StuAdmInfo']) {
          this.personalDetailsForm.controls['StuAdmInfo'].patchValue(
            this.DownloadDetails['StuAdmInfo']
          );
        }
        if (this.DownloadDetails['StuMaritalStat']) {
          this.personalDetailsForm.controls['StuMaritalStat'].patchValue(
            this.DownloadDetails['StuMaritalStat']
          );
        }
        if (this.DownloadDetails['StuDomicile']) {
          this.contactDetailsForm.controls['StuDomicile'].patchValue(
            this.DownloadDetails['StuDomicile']
          );
        }
        if (this.DownloadDetails['StuNationality']) {
          this.contactDetailsForm.controls['StuNationality'].patchValue(
            this.DownloadDetails['StuNationality']
          );
        }
        if (this.DownloadDetails['StuAddrC']) {
          this.contactDetailsForm.controls['StuAddrC'].patchValue(
            this.DownloadDetails['StuAddrC']
          );
        }

        if (this.DownloadDetails['StuAddr2C']) {
          this.contactDetailsForm.controls['StuAddr2C'].patchValue(
            this.DownloadDetails['StuAddr2C']
          );
        }
        if (this.DownloadDetails['StuAddr3C']) {
          this.contactDetailsForm.controls['StuAddr3C'].patchValue(
            this.DownloadDetails['StuAddr3C']
          );
        }
        if (this.DownloadDetails['StuAddr4C']) {
          this.contactDetailsForm.controls['StuAddr4C'].patchValue(
            this.DownloadDetails['StuAddr4C']
          );
        }

        if (this.DownloadDetails['StuCountryC']) {
          this.contactDetailsForm.controls['StuCountryC'].patchValue(
            this.DownloadDetails['StuCountryC']
          );
        }
        if (this.DownloadDetails['StuStateC']) {
          this.contactDetailsForm.controls['StuStateC'].patchValue(
            this.DownloadDetails['StuStateC']
          );
        }
        if (this.DownloadDetails['StuDistrictC']) {
          this.contactDetailsForm.controls['StuDistrictC'].patchValue(
            this.DownloadDetails['StuDistrictC']
          );
        }
        if (this.DownloadDetails['StuTehsilC']) {
          this.contactDetailsForm.controls['StuTehsilC'].patchValue(
            this.DownloadDetails['StuTehsilC']
          );
        }
        if (this.DownloadDetails['StuCityC']) {
          this.contactDetailsForm.controls['StuCityC'].patchValue(
            this.DownloadDetails['StuCityC']
          );
        }
        if (this.DownloadDetails['StuCountryP']) {
          this.contactDetailsForm.controls['StuCountryP'].patchValue(
            this.DownloadDetails['StuCountryP']
          );
        }
        if (this.DownloadDetails['StuAddr2P']) {
          this.contactDetailsForm.controls['StuAddr2P'].patchValue(
            this.DownloadDetails['StuAddr2P']
          );
        }
        if (this.DownloadDetails['StuAddr3P']) {
          this.contactDetailsForm.controls['StuAddr3P'].patchValue(
            this.DownloadDetails['StuAddr3P']
          );
        }
        if (this.DownloadDetails['StuAddr4P']) {
          this.contactDetailsForm.controls['StuAddr4P'].patchValue(
            this.DownloadDetails['StuAddr4P']
          );
        }
        if (this.DownloadDetails['StuStateP']) {
          this.contactDetailsForm.controls['StuStateP'].patchValue(
            this.DownloadDetails['StuStateP']
          );
        }
        if (this.DownloadDetails['StuDistrictP']) {
          this.contactDetailsForm.controls['StuDistrictP'].patchValue(
            this.DownloadDetails['StuDistrictP']
          );
        }
        if (this.DownloadDetails['StuRegion']) {
          this.contactDetailsForm.controls['StuRegion'].patchValue(
            this.DownloadDetails['StuRegion']
          );
        }
        if (this.DownloadDetails['StuConstiSubCate']) {
          this.reservationsDetailsForm.controls['StuConstiSubCate'].patchValue(
            this.DownloadDetails['StuConstiSubCateStu']
          );
        }
        if (this.DownloadDetails['StuCaste']) {
          this.reservationsDetailsForm.controls['StuCaste'].patchValue(
            this.DownloadDetails['StuCaste']
          );
        }
        else{
          this.reservationsDetailsForm.controls['StuCaste'].patchValue('');
        }
        if (this.DownloadDetails['StuCasteCert']) {
          this.reservationsDetailsForm.controls['StuCasteCert'].patchValue(
            this.DownloadDetails['StuCasteCert']
          );
        }
        if (this.DownloadDetails['StuCasteValCert']) {
          this.reservationsDetailsForm.controls['StuCasteValCert'].patchValue(
            this.DownloadDetails['StuCasteValCert']
          );
        }
        if (this.DownloadDetails['StuNonCrmCert']) {
          this.reservationsDetailsForm.controls['StuNonCrmCert'].patchValue(
            this.DownloadDetails['StuNonCrmCert']
          );
        }
        if (this.DownloadDetails['StuInHouse']) {
          this.reservationsDetailsForm.controls['StuInHouse'].patchValue(
            this.DownloadDetails['StuInHouse']
          );
        }

        if (this.DownloadDetails['StuMinority']) {
          this.reservationsDetailsForm.controls['StuMinority'].patchValue(
            this.DownloadDetails['StuMinority']
          );
        }
        if (this.DownloadDetails['StuMinorityType']) {
          this.reservationsDetailsForm.controls['StuMinorityType'].patchValue(
            this.DownloadDetails['StuMinorityType']
          );
        }
        if (this.DownloadDetails['StuMinorityType2']) {
          this.reservationsDetailsForm.controls['StuMinorityType2'].patchValue(
            this.DownloadDetails['StuMinorityType2']
          );
        }
        if (this.DownloadDetails['StuSpecialAbledType']) {
          this.reservationsDetailsForm.controls['StuSpecialAbledType'].patchValue(
            this.DownloadDetails['StuSpecialAbledType']
          );
        }
        if (this.DownloadDetails['StuPhyHand']) {
          this.reservationsDetailsForm.controls['StuPhyHand'].patchValue(
            this.DownloadDetails['StuPhyHand']
          );
        }
        if (this.DownloadDetails['StuOrphan']) {
          this.reservationsDetailsForm.controls['StuOrphan'].patchValue(
            this.DownloadDetails['StuOrphan']
          );
        }
        if (this.DownloadDetails['StuSociaLReservation']) {
          this.reservationsDetailsForm.controls['StuSocialRes'].patchValue(
            this.DownloadDetails['StuSociaLReservation']
          );
        }
        if (this.DownloadDetails['BPLCategory']) {
          this.reservationsDetailsForm.controls['BPLCategory'].patchValue(
            this.DownloadDetails['BPLCategory']
          );
        }


        if (this.DownloadDetails['StuVoterId']) {
          this.additionalDetailsForm.controls['StuVoterId'].patchValue(
            this.DownloadDetails['StuVoterId']
          );
        }
        if (this.DownloadDetails['StuAadhaarNo']) {
          this.additionalDetailsForm.controls['StuAadhaarNo'].patchValue(
            this.DownloadDetails['StuAadhaarNo']
          );
        }
        if (this.DownloadDetails['StuAadhar']) {
          this.additionalDetailsForm.controls['StuAadhar'].patchValue(
            this.DownloadDetails['StuAadhar']
          );
        }

        if(this.DownloadDetails['StuAadhar'] == 'No'){
          this.ShowAadharNo = false;
           }
           else{
             this.ShowAadharNo = true;
           }
        if (this.DownloadDetails['StuPanNo']) {
          this.additionalDetailsForm.controls['StuPanNo'].patchValue(
            this.DownloadDetails['StuPanNo']
          );
        }
        if (this.DownloadDetails['StuOrgDonate']) {
          this.additionalDetailsForm.controls['StuOrgDonate'].patchValue(
            this.DownloadDetails['StuOrgDonate']
          );
        }
        if (this.DownloadDetails['StuHostelAccod']) {
          this.additionalDetailsForm.controls['StuHostelAccod'].patchValue(
            this.DownloadDetails['StuHostelAccod']
          );
        }

        if (this.DownloadDetails['StuEmpType']) {
          this.additionalDetailsForm.controls['StuEmpType'].patchValue(
            this.DownloadDetails['StuEmpType']
          );
        }
        if (this.DownloadDetails['StuABCId']) {
          this.additionalDetailsForm.controls['StuABCId'].patchValue(
            this.DownloadDetails['StuABCId']
          );
        }
        if(this.DownloadDetails['StuABCId'] == 'No'){
       this.HideAbcId = false;
       this.HideAddhar= true;
        }
        else{
          this.HideAbcId = true;
          this.HideAddhar= false;
        }
        if (this.DownloadDetails['StuABCId2']) {
          this.additionalDetailsForm.controls['StuABCId2'].patchValue(
            this.DownloadDetails['StuABCId2']
          );
        }
        if (this.DownloadDetails['StuAadharPhone']) {
          this.additionalDetailsForm.controls['StuAadharPhone'].patchValue(
            this.DownloadDetails['StuAadharPhone']
          );
        }
        
        if (this.DownloadDetails['StuDistrictAd']) {
          this.additionalDetailsForm.controls['StuDistrictAd'].patchValue(
            this.DownloadDetails['DsName']
          );
        }

        if (this.DownloadDetails['StuStudyCenter']) {
          this.additionalDetailsForm.controls['StuStudyCenter'].patchValue(
            this.DownloadDetails['CgName']
          );
        }
        if (this.DownloadDetails['StuMedium']) {
          this.additionalDetailsForm.controls['StuMedium'].patchValue(
            this.DownloadDetails['StuMedium']
          );
        }
        
        if (this.DownloadDetails['StuCoLvl']) {
          this.qualificationDetailsForm.controls['StuCoLvl'].patchValue(
            this.DownloadDetails['StuCoLvl']
          );
        }
        if (this.DownloadDetails['StuQualStr']) {
          this.qualificationDetailsForm.controls['StuQualStr'].patchValue(
            this.DownloadDetails['StuQualStr']
          );
        }
        if (this.DownloadDetails['StuStyMode']) {
          this.admissionDetailsForm.controls['StuStyMode'].patchValue(
            this.DownloadDetails['StuStyMode']
          );
        }
        if (this.DownloadDetails['StuType']) {
          this.admissionDetailsForm.controls['StuType'].patchValue(
            this.DownloadDetails['StuType']
          );
        }
        if (this.DownloadDetails['StuFacId']) {
          this.admissionDetailsForm.controls['StuFacId'].patchValue(
            this.DownloadDetails['StuFacId']
          );
        }
        if (this.DownloadDetails['StuCoId']) {
          this.admissionDetailsForm.controls['StuCoId'].patchValue(
            this.DownloadDetails['StuCoId']
          );
        }
        if (this.DownloadDetails['StuBrId']) {
          this.admissionDetailsForm.controls['StuBrId'].patchValue(
            this.DownloadDetails['StuBrId']
          );
        }
        else{
          this.admissionDetailsForm.controls['StuBrId'].patchValue('');
        }
        if (this.DownloadDetails['StuEmId']) {
          this.admissionDetailsForm.controls['StuEmId'].patchValue(
            this.DownloadDetails['StuEmId']
          );
        }
        // if (this.DownloadDetails['StuSubjectRg']) {
        //   this.admissionDetailsForm.controls['StuSubjectRg'].patchValue(
        //     this.DownloadDetails['StuSubjectRg']
        //   );
        // }
        if (this.DownloadDetails['StuCgId']) {
          this.admissionDetailsForm.controls['StuCgId'].patchValue(
            this.DownloadDetails['StuCgId']
          );
        }
      } else {
        this.spinner.hide();
        //this.apimicroservice.openSnackbar(res.message);
      }
    });
  }

  prepop_fetchReservationDetails() {
    this.spinner.show();
    let payload = {};
    payload['StuId'] = this.StudentPersonalId;
    this.umsService.fetchReservationDetails(payload).subscribe((res) => {
      if (res.status) {
        this.spinner.hide();
        if (res.data.length > 0) {
          res.data[0].StuCaste = parseInt(res.data[0].StuCaste);
          sessionStorage.setItem('StudentPersonalId', res.data[0].StuId);
          this.prepop_fetchReservationDetails_Form(res);
          let e = '';
        }
      }
      else{
        this.spinner.hide();
      }
    });
  }

  prepop_fetchQualificationDetails() {
    this.spinner.show();
    let payload = {};
    payload['StuId'] = this.StudentPersonalId;
    this.umsService.fetchQualificationDetails(payload).subscribe((res) => {
      if (res.status) {
        this.spinner.hide();
        res.data.StuCgpi = parseFloat(res.data.StuCgpi);
        res.data.StuPassYr = parseInt(res.data.StuPassYr);
        if (res.data.length > 0) {
          this.prepop_fetchQualificationDetails_Form(res);
        } 
        // else {
        //   this.loadsettingspageQualification();
        // }
      }
       else {
        this.spinner.hide();
      }
    });
  }

  prepop_fetchQualificationDetails_Form(e) {
    let payload = {};
    payload['FormPage'] = 'QualifyDetails';
    this.qualificationDetailsForm.controls['StuQualId'].setValue(
      e.data[0]['StuQualId']
    );
    this.umsService.getStdSetting(payload).subscribe(async (ress) => {
      ress.data.forEach((element) => {
        if (element.FormVisible) {
          if (element.FormRequired) {
            if (element.FormPattern == '') {
              this.qualificationDetailsForm.addControl(
                element.FormControlName,
                new FormControl(
                  e.data[0][element.FormControlName],
                  Validators.required
                )
              );
            } else {
              this.qualificationDetailsForm.addControl(
                element.FormControlName,
                new FormControl(e.data[0][element.FormControlName], [
                  Validators.required,
                  Validators.pattern(element.FormPattern),
                ])
              );
            }
          } else {
            if (element.FormPattern == '') {
              this.qualificationDetailsForm.addControl(
                element.FormControlName,
                new FormControl(e.data[0][element.FormControlName])
              );
            } else {
              this.qualificationDetailsForm.addControl(
                element.FormControlName,
                new FormControl(e.data[0][element.FormControlName], [
                  Validators.pattern(element.FormPattern),
                ])
              );
            }
          }
        } else {
          this.qualificationDetailsForm.addControl(
            element.FormControlName,
            new FormControl(e.data[0][element.FormControlName])
          );
        }
      });
      this.qualificationDetailsFormArray = ress.data.reduce(function (r, a) {
        r[a.FormControlName] = r[a.FormControlName] || [];
        r[a.FormControlName].push(a);
        return r;
      }, Object.create(null));
      await this.prepop_fetchAdditionalDetails();
    });
    this.fetchQualDetailsForTable();
  }

  prepop_fetchReservationDetails_Form(e) {
    let payload = {};
    payload['FormPage'] = 'ReserveDetails';
    this.reservationsDetailsForm.controls['StuResId'].setValue(
      e.data[0]['StuResId']
    );
    this.umsService.getStdSetting(payload).subscribe(async(ress) => {
      this.valueForMakeReq1 = ress.data;
      ress.data.forEach((element) => {
        if (element.FormVisible) {
          if (element.FormRequired) {
            this.reservationsDetailsForm.addControl(
              element.FormControlName,
              new FormControl(
                e.data[0][element.FormControlName],
                Validators.required
              )
            );
          } else {
            if (element.FormPattern == '') {
              this.reservationsDetailsForm.addControl(
                element.FormControlName,
                new FormControl(e.data[0][element.FormControlName])
              );
            } else {
              this.reservationsDetailsForm.addControl(
                element.FormControlName,
                new FormControl(e.data[0][element.FormControlName], [
                  Validators.pattern(element.FormPattern),
                ])
              );
            }
          }
        } else {
          this.reservationsDetailsForm.addControl(
            element.FormControlName,
            new FormControl(e.data[0][element.FormControlName])
          );
        }
      });
      this.reservationsDetailsFormArray = ress.data.reduce(function (r, a) {
        r[a.FormControlName] = r[a.FormControlName] || [];
        r[a.FormControlName].push(a);
        return r;
      }, Object.create(null));
      // this.dependancy(e);
      await this.prepop_fetchQualificationDetails();
    
    });
  }
  prepop_fetchAdditionalDetails() {
    let payload = {};
    payload['StuId'] = this.StudentPersonalId;
    this.umsService.fetchAdditionalDetails(payload).subscribe((res) => {
      if (res.status) {
        this.fetchDate(res.data)
        if (res.data.length > 0) {
          this.umsService.disable5 = false;
          sessionStorage.setItem('StudentPersonalId', res.data[0].StuId);
          this.submitButton = false;
          this.updateButton = true;
          //  StudentPersonalId = sessionStorage.getItem('StudentPersonalId');
          this.prepop_fetchAdditionalDetails_Form(res);
        }
      }
    });
  }


  prepop_fetchAdditionalDetails_Form(e) {
    let payload = {};
    payload['FormPage'] = 'AdditionalDetail';
    this.additionalDetailsForm.controls['StuExtraId'].setValue(
      e.data[0]['StuExtraId']
    );
    this.umsService.getStdSetting(payload).subscribe(async(ress) => {
      ress.data.forEach((element) => {
        if (element.FormVisible) {
          if (element.FormRequired) {
            if (element.FormPattern == '') {
              this.additionalDetailsForm.addControl(
                element.FormControlName,
                new FormControl(
                  e.data[0][element.FormControlName],
                  Validators.required
                )
              );
            } else {
              this.additionalDetailsForm.addControl(
                element.FormControlName,
                new FormControl(e.data[0][element.FormControlName], [
                  Validators.required,
                  Validators.pattern(element.FormPattern),
                ])
              );
            }
          } else {
            if (element.FormPattern == '') {
              this.additionalDetailsForm.addControl(
                element.FormControlName,
                new FormControl(e.data[0][element.FormControlName])
              );
            } else {
              this.additionalDetailsForm.addControl(
                element.FormControlName,
                new FormControl(e.data[0][element.FormControlName], [
                  Validators.pattern(element.FormPattern),
                ])
              );
            }
          }
        } else {
          this.additionalDetailsForm.addControl(
            element.FormControlName,
            new FormControl(e.data[0][element.FormControlName])
          );
        }
      });
      this.additionalDetailsFormArray = ress.data.reduce(function (r, a) {
        r[a.FormControlName] = r[a.FormControlName] || [];
        r[a.FormControlName].push(a);
        return r;
      }, Object.create(null));
      await this.prepop_fetchAddmissionDetails();
    });
  }

  loadsettingspageQualification() {
    let payload = {};
    payload['FormPage'] = 'QualifyDetails';
    this.umsService.getStdSetting(payload).subscribe((res) => {
      res.data.forEach((element) => {
        if (element.FormVisible) {
          if (element.FormRequired) {
            if (element.FormPattern == '') {
              this.qualificationDetailsForm.addControl(
                element.FormControlName,
                new FormControl('', Validators.required)
              );
            } else {
              this.qualificationDetailsForm.addControl(
                element.FormControlName,
                new FormControl('', [
                  Validators.required,
                  Validators.pattern(element.FormPattern),
                ])
              );
            }
          } else {
            if (element.FormPattern == '') {
              this.qualificationDetailsForm.addControl(
                element.FormControlName,
                new FormControl('')
              );
            } else {
              this.qualificationDetailsForm.addControl(
                element.FormControlName,
                new FormControl('', [Validators.pattern(element.FormPattern)])
              );
            }
          }
        }
      });
      this.qualificationDetailsFormArray = res.data.reduce(function (r, a) {
        r[a.FormControlName] = r[a.FormControlName] || [];
        r[a.FormControlName].push(a);
        return r;
      }, Object.create(null));
    });

    this.fetchQualDetailsForTable();
  }

  convertToBase64(file: File) {
    const observable = new Observable((subscriber: Subscriber<any>) => {
      this.readFile(file, subscriber);
    });

    observable.subscribe((d) => {
      this.uploadDoc = d;
    });
  }
  readFile(file: File, subscriber: Subscriber<any>) {
    const fileReader = new FileReader();
    fileReader.readAsDataURL(file);

    fileReader.onload = () => {
      subscriber.next(fileReader.result);
      subscriber.complete();
    };
    fileReader.onerror = (error) => {
      subscriber.error(error);
      subscriber.complete();
    };
  }

  fetchQualDetailsForTable() {
    this.spinner.show();
    let payload = {};
    payload['StuId'] = this.StudentPersonalId;
    payload['StuQualId'] = '';
    this.umsService.fetchQualificationDetails(payload).subscribe((res) => {
      this.qualList = res.data;
      if (res.data.length == 0) { 
         this.spinner.hide();
        this.isDivShow = false;
        this.nextButton = false;
      } else {
        this.spinner.hide();
        this.umsService.disable4 = false;
        this.isDivShow = true;
        this.nextButton = true;
      }
    });
  }

  percentage() {
    const StuMarksObt = this.qualificationDetailsForm.value.StuMarksObt;
    const StuMarksTot = this.qualificationDetailsForm.value.StuMarksTot;
    var percentage = ((StuMarksObt / StuMarksTot) * 100).toFixed(2);
    // this.qualificationDetailsForm.controls['StuPercent'].setValue(percentage);
    if (parseInt(percentage) == 100) {
      this.qualificationDetailsForm.controls['StuPercent'].setValue(100);
    } else {
      this.qualificationDetailsForm.controls['StuPercent'].setValue(percentage);
    }
  }

  resetForm() {
    this.updateButton = false;
    this.deleteButton = false;
    this.submitButton = true;
    this.nextButton = true;
    this.resetButton = false;
    this.delReadOnly = false;
    this.resultNotDec = false;
    this.qualificationDetailsForm.reset();
  }

  showbase64(e) {
    const dialogRef3 = this.dialog.open(PdfviewerComponent, {
      width: '400px',
      height: '500px',
      data: e.fileUploadData,
      disableClose: true,
    });
  }

  todate(event: any) {
    let dateeee = this.additionalDetailsForm.value.StuToDate;
    let toDate = this.datepipe.transform(dateeee, 'yyyy-MM-dd');
    if (
      this.additionalDetailsForm.value.StuFromDate == '' ||
      this.datepipe.transform(
        this.additionalDetailsForm.value.StuFromDate,
        'yyyy-MM-dd'
      ) == ''
    ) {
      let data = {};
      data['message'] = 'Select Valid From Date';
      data['title'] = 'Information';
      data['icon'] = 'fas fa-check';
      this.dialogRef = this.modalPopupService.openPopup<AlertboxComponent>(
        AlertboxComponent,
        data
      );
      this.additionalDetailsForm.controls['StuToDate'].setValue('');
    } else if (
      this.additionalDetailsForm.value.StuFromDate >= toDate ||
      this.datepipe.transform(
        this.additionalDetailsForm.value.StuFromDate,
        'yyyy-MM-dd'
      ) >= toDate
    ) {
      let data = {};
      data['message'] = 'Valid Till Date should Not Less Than From Date';
      data['title'] = 'Information';
      data['icon'] = 'fas fa-check';
      this.dialogRef = this.modalPopupService.openPopup<AlertboxComponent>(
        AlertboxComponent,
        data
      );
      this.additionalDetailsForm.controls['StuToDate'].setValue('');
    }
  }

  checkMatchingOpCode(group: any) {
    return this.optData.some((item) => item.OpCode === group.EsOpCode);
  }

  validateCheckboxesForItem(): void {
    for (const item of this.optData) {
      const selectedForItem = this.selectedCheckboxes.filter(
        (checkbox) => checkbox.EsOpCode === item.OpCode
      );
      this.validateCheckboxes(item, selectedForItem);
    }
  }

  validateCheckboxes(item: any, selectedCheckboxes1: any[]): void {
    const totalSelected = selectedCheckboxes1.length;
    const opMin = item.OpMin;
    const opMax = item.OpMax;
    const opCode = item.OpCode;
    if (totalSelected < opMin || totalSelected > opMax) {
      this.validationErrors[
        item.OpCode
      ] = `For OptionCode ${opCode} Select Minimum ${opMin} or Maximum ${opMax}`;
    } else {
      delete this.validationErrors[item.OpCode];
      this.noCheckboxSelected = false;
      this.disabled = false;
    }
    this.getValidationErrorsKeys();
  }

  getValidationErrorsKeys(): string[] {
    return Object.keys(this.validationErrors);
  }

  getScretData() {
    this.spinner.show();
    this.umsService.getSecretData().subscribe((res) => {
      this.spinner.hide();
      this.InstId = res.projectPharam['ClubPartTrans'];
      this.InsNm = res.projectPharam['InstituteName'];
    });
  }

  prepop_fetchAddmissionDetails() {
    this.spinner.show();
    let payload = {};
    payload['StuId'] = this.StudentPersonalId;
    this.umsService.fetchAddmissionDetails(payload).subscribe((res) => {
      if (res.status) {
        this.spinner.hide();
        res.data[0].StuBrId = parseInt(res.data[0].StuBrId);
        res.data[0].StuEmId = parseInt(res.data[0].StuEmId);
        res.data[0].StuSubjectRg = res.data[0].StuSubjectRg.split(',');
        if (res.data.length > 0) {
          sessionStorage.setItem('StudentPersonalId', res.data[0].StuId);
          sessionStorage.setItem('StuAcadId', res.data[0].StuAcadId);
          this.umsService.disable7 = false;
          this.selectedValues = res.data[0].StuSubjectRg;
          const dataArray = res.data[0].StuSubjectRgCopy.split(',');
          dataArray.forEach((item) => {
            const splitValues = item.split('-');
            const obj = {
              Code: splitValues[0],
              Id: splitValues[1],
            };
            this.newSelectedValues.push(obj);
          });
          this.prepop_fetchAddmissionDetails_Form(res);
        }
      } 
      else{
        this.spinner.hide();
      }
    });
  }

  prepop_fetchAddmissionDetails_Form(e) {
    let payload = {};
    payload['FormPage'] = 'AdmDetails';
    this.umsService.getStdSetting(payload).subscribe(async (ress) => {
      ress.data.forEach((element) => {
        if (element.FormVisible) {
          if (element.FormRequired) {
            if (element.FormPattern == '') {
              this.admissionDetailsForm.addControl(
                element.FormControlName,
                new FormControl(
                  e.data[0][element.FormControlName],
                  Validators.required
                )
              );
            } else {
              this.admissionDetailsForm.addControl(
                element.FormControlName,
                new FormControl(e.data[0][element.FormControlName], [
                  Validators.required,
                  Validators.pattern(element.FormPattern),
                ])
              );
            }
          } else {
            if (element.FormPattern == '') {
              this.admissionDetailsForm.addControl(
                element.FormControlName,
                new FormControl(e.data[0][element.FormControlName])
              );
            } else {
              this.admissionDetailsForm.addControl(
                element.FormControlName,
                new FormControl(e.data[0][element.FormControlName])
              );
            }
          }
        } else {
          this.admissionDetailsForm.addControl(
            element.FormControlName,
            new FormControl(e.data[0][element.FormControlName])
          );
        }
      });
      this.admissionDetailsFormArray = ress.data.reduce(function (r, a) {
        r[a.FormControlName] = r[a.FormControlName] || [];
        r[a.FormControlName].push(a);
        return r;
      }, Object.create(null));
      await this.fetchDownloadDetails();
    });
  }

  fileUploads: string[] = [];

  
 
  prepopulationPhoto() {
    this.spinner.show();
    let payload = {};
    payload['StuId'] = this.StudentPersonalId;
    this.umsService.fetchPhotoSignDetails(payload).subscribe((res) => {
      sessionStorage.setItem('ProfileImg', res.data[0].StuPhoto);
      const data = res.data[0];
      this.proId = res.data[0].StuProfId;
      if (res.status) {
        this.spinner.hide();
        if (res.data.length > 0) {
          this.umsService.disable6 = false;
          this.submitButton = false;
          this.updateButton = true;
          this.photoSignDetailsForm = this.fb.group({
            StuId: new FormControl(data.StuId),
            StuRgNo: new FormControl(data.StuRgNo),
            StuPhoto: new FormControl(data.StuPhoto, Validators.required),
            StuSignature: new FormControl(
              data.StuSignature,
              Validators.required
            ),
          });
          this.userImage = res.data[0].StuPhoto;
          this.signatureImage = res.data[0].StuSignature;
          if (res.data[0].StuPhoto == '') {
            let img = '../../assets/images/user2.png';
            sessionStorage.setItem(
              'ProfileImg',
              '../../assets/images/user2.png'
            );
            this.umsService.getNoimg(img);
          } else {
            sessionStorage.setItem('ProfileImg', this.userImage);
          }
        } else {
          this.submitButton = true;
          this.updateButton = false;
        }
      } else {
        this.spinner.hide();
      }
    });
  }

  shouldCheckItemForGroup(child): boolean {
    return this.selectedCheckboxes.some((item) => item.EsId === child.EsId);
  }

  shouldCheckItemForSubject(item1): boolean {
    return this.selectedCheckboxes.some((item) => item.EsId === item1.EsId);
  }

  downloadAsPDF() {
    this.spinner.show();
    
    // Extracting first name, middle name, and last name
    const firstName = this.personalDetailsForm.get('StuFirstNameEng').value;
    const middleName = this.personalDetailsForm.get('StuMidNameEng').value;
    const lastName = this.personalDetailsForm.get('StuLastNameEng').value;
    
    // Generating filename
    const filename = `${firstName} ${middleName} ${lastName}.pdf`;
  
    // Options for pdf generation
    const options: html2pdf.Options = {
      filename: filename,
      image: { type: 'jpeg', quality: 1.0 },
      html2canvas: { scale: 4 },
      jsPDF: { unit: 'in', format: 'A4', orientation: 'landscape' },
    };
  
    const element = this.contentToConvert.nativeElement.cloneNode(true) as HTMLElement; // Clone the element to avoid modifying the original
  
    // Apply styles for printing
    const labels = element.querySelectorAll('.mat-form-field-label-wrapper');
    labels.forEach((label) => {
      (label as HTMLElement).style.transform =
        'translateY(-1.48125em) scale(0.75) perspective(10px) translateZ(0.001px)';
    });
  
    // Replace label elements with their inner text
    labels.forEach((label) => {
      const textNode = document.createTextNode((label.textContent as string).trim()); // Use inner text of label
      (label.parentNode as HTMLElement).insertBefore(textNode, label.nextSibling); // Insert text node after the label
      label.remove(); // Remove the label element
    });
  
    const inputs = element.querySelectorAll('input');
    inputs.forEach((input) => {
      const value = (input as HTMLInputElement).value.trim();
      const valueContainer = document.createElement('div'); // Create a <div> container for the value
      valueContainer.textContent = value !== '' ? value : ' '; // If value is empty, add a space character as placeholder
      (input.parentNode as HTMLElement).appendChild(valueContainer); // Append the <div> container after the input
      input.remove(); // Remove the input element
    });
  
// Add page break styles more specifically
const addPageBreaks = (element: HTMLElement) => {
  const formGroups = [
    { id: 'personalDetailsForm', pageBreak: 'auto' },
    { id: 'contactDetailsForm', pageBreak: 'always' },
    { id: 'reservationsDetailsForm', pageBreak: 'always' },
    { id: 'qualificationDetailsForm', pageBreak: 'always' },
    { id: 'additionalDetailsForm', pageBreak: 'always' },
    { id: 'admissionDetailsForm', pageBreak: 'always' },
  ];

  formGroups.forEach((group) => {
    const groupElement = element.querySelector(`#${group.id}`);
    if (groupElement) {
      (groupElement as HTMLElement).style.pageBreakBefore = group.pageBreak;
    }
  });
};

// const addPageBreaks = (element: HTMLElement) => {
//   // Clear existing page break styles
//   element.querySelectorAll('.page-break').forEach((el) => {
//       el.classList.remove('page-break');
//   }); 

//   // Adding a class for page breaks
//   const formGroups = [
//       { id: 'personalDetailsForm', pageBreak: 'always' }, // Ensure break after personalDetailsForm
//       { id: 'contactDetailsForm', pageBreak: 'auto' },
//       { id: 'reservationsDetailsForm', pageBreak: 'always' },
//       { id: 'qualificationDetailsForm', pageBreak: 'auto' },
//       { id: 'admissionDetailsForm', pageBreak: 'auto' },
//       { id: 'additionalDetailsForm', pageBreak: 'auto' }
//   ];

//   formGroups.forEach(({ id, pageBreak }) => {
//       const groupElement = element.querySelector(`#${id}`);
//       if (groupElement) {
//           groupElement.classList.add('page-break'); // Add class for styling
//           if (id === 'personalDetailsForm') {
//             (groupElement as HTMLElement).style.pageBreakAfter = 'always'; // Ensure a break after this form
//           }
//       }
//   });
// }
    
    addPageBreaks(element);
    
    // Generate and save the PDF
    html2pdf().from(element).set(options).save();
    
    this.spinner.hide();
  }

  fetchDate(item) {
    // StuFromDate
    if (item[0].StuFromDate == "1970-01-01" && item[0].StuToDate == "1970-01-01") {
      item[0].StuFromDate = '';
      item[0].StuToDate = ''
    }
  }



  Back() {
    this.goBack();
  }
  goBack(): void {
    this.location.back(); 
  }
}
